package com.essntl.features.supplier.data.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("com.essntl.features.supplier.data")
class SupplierModule
